import { render, staticRenderFns } from "./garage-management.vue?vue&type=template&id=f5470ee4"
import script from "./garage-management.vue?vue&type=script&lang=ts"
export * from "./garage-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports